import { render, staticRenderFns } from "./works-scene-bar.vue?vue&type=template&id=096abe74&scoped=true"
import script from "./works-scene-bar.vue?vue&type=script&lang=js"
export * from "./works-scene-bar.vue?vue&type=script&lang=js"
import style0 from "./works-scene-bar.vue?vue&type=style&index=0&id=096abe74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096abe74",
  null
  
)

export default component.exports